<template>
  <div id="rateassist-distances-tab-content">
    <div class="row">
      <div class="col-xs-12">
        <blockquote>
          Add a distance band
          <div class="btn btn-primary sq pull-right" @click="addRow">
            Add
          </div>
        </blockquote>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="form-label" for="bp-type">Distance Type</label>
            <select v-model="distanceType" id="bp-type" class="form-control">
              <option value=""></option>
              <option v-for="option in distances" :value="option.id">{{ option.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-xs-12" v-for="(dis, i) in distanceEntries">
          <div class="shadow clearfix">
            <hr class="hr-text" :data-content="`BAND ${i + 1}`"/>
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label :for="'dis-min-' + i" class="form-label">Minmimum</label>
                <input type="number" step="0.01" class="form-control" :id="'dis-min-' + i" v-model="dis.minimumValue"/>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label :for="'dis-max-' + i" class="form-label">Maximum</label>
                <input type="number" step="0.01" class="form-control" :id="'dis-max-' + i" v-model="dis.maximumValue"/>
              </div>
            </div>
            <div class="col-xs-12">
              <hr>
              <div class="pull-right">
                <div class="btn btn-danger" @click="remove(i)">
                  Delete
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  export default {
    name: 'Distances',
    mixins: [ LookupHelperMixin ],
    props: ['dt', 'details'],
    data () {
      return {
        distanceType: null,
        distanceEntries: []
      }
    },
    watch: {
      distanceType (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('updating', { distanceType: newVal, distanceEntries: this.distanceEntries })
        }
      },
      distanceEntries: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            this.$emit('updating', { distanceType: this.distanceType, distanceEntries: newVal })
          }
        }
      },
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          for (let prop in newVal) {
            if (this.hasOwnProperty(prop) && JSON.stringify(this[prop]) !== JSON.stringify(newVal[prop])) {
              this[prop] = newVal[prop]
            }
          }
        }
      },
      dt (newVal, oldVal) {
        if (this.distanceType !== newVal && newVal !== oldVal) {
          this.distanceType = newVal
        }
      }
    },
    computed: {
      distances () {
        return this.sortedOptions('DISTANCE_TYPE')
      }
    },
    methods: {
      sortedOptions (type) {
        return this.getSystemOptions(type).sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      },
      updateSequence () {
        this.distanceEntries.forEach((o, index) => {
          o.sequence = index + 1
        })
      },
      addRow () {
        this.distanceEntries.push({
          minimumValue: 0,
          maximumValue: 0,
          category: 'DISTANCE_TYPE',
          sequence: null
        })
        this.$emit('updating', { distanceType: this.distanceType, distanceEntries: this.distanceEntries })
        this.updateSequence()
      },
      remove (i) {
        this.distanceEntries.splice(i, 1)
        this.$emit('updating', { distanceType: this.distanceType, distanceEntries: this.distanceEntries })
        this.updateSequence()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/rateassist/components/Distances.vue